import type { PaymentMethodConfig, PaymentMethodId } from '@/types/payment'
import { PaymentMethodCard } from '@/components/deposit/PaymentMethodCard'
import { getDepositActionButtonClassName } from '@/components/deposit/styles'
import { Button } from '../ui/button'
interface MethodStepProps {
	currencyLabel: string
	methods: PaymentMethodConfig[]
	selectedMethodId: PaymentMethodId | null
	onSelectMethod: (methodId: PaymentMethodId) => void
	onContinue: () => void
	canContinue: boolean
}

export function MethodStep({ currencyLabel, methods, selectedMethodId, onSelectMethod, onContinue, canContinue }: MethodStepProps) {
	return (
		<div className='flex min-h-0 flex-1 flex-col gap-6'>
			<div className='flex flex-1 flex-col gap-3'>
				{methods.length > 0 ? (
					methods.map((method) => (
						<PaymentMethodCard key={method.id} method={method} isSelected={selectedMethodId === method.id} onSelect={() => onSelectMethod(method.id)} />
					))
				) : (
					<p className='rounded-xl border border-border bg-secondary px-4 py-6 text-center text-sm text-muted-foreground'>
						No payment methods are available for {currencyLabel || 'this currency'}.
					</p>
				)}
			</div>

			<Button type='button' onClick={onContinue} disabled={!canContinue} variant='primary'>
				Deposit
			</Button>
		</div>
	)
}
